export interface ReturnAttachmentUrlRequestParams {
  orderNumber: string;
  returnAttachmentUrlRequest: ReturnAttachmentUrlRequest;
}

export interface ReturnAttachmentUrlRequest {
  returnCaseAttachment: ReturnCaseAttachment;
}

export interface ReturnCaseAttachment {
  file_name: string;
  extension?: string;
  url?: string;
}

export interface ReturnRequestParams {
  returnRequest: ReturnRequest;
  orderId: number;
}

export interface ReturnRequest {
  return: OrderReturn;
}

export interface OrderReturn {
  notify_user: boolean;
  return_case: ReturnType;
  return_case_attachment?: ReturnCaseAttachment;
  return_reason: ReturnReason;
  items: ReturnRequestItem[];
}

export enum ReturnType {
  RETURN = 'RETURN',
  SFDC_CASE = 'SFDC_CASE'
}

export enum ReturnReason {
  CLASS_CANCELLED = 'CLASS_CANCELLED',
  PURCHASED_WRONG_EMAIL = 'PURCHASED_WRONG_EMAIL',
  PURCHASED_WRONG_PRODUCT = 'PURCHASED_WRONG_PRODUCT',
  UNRESOLVED_TECHNICAL_ISSUE = 'UNRESOLVED_TECHNICAL_ISSUE'
}

export interface ReturnRequestItem {
  sku: string;
  reason_code: string;
}

export interface ReturnResponse {
  orderId: number;
  orderIncrementId: string;
  caseNumber?: string;
  items: ReturnItem[];
}

export interface ReturnItem {
  sku: string;
  success: boolean;
  message?: string;
}

export interface MagentoReturnResponse {
  order_id: number;
  order_increment_id: string;
  return_case_number: string;
  items: ReturnItem[];
}